import React from "react";
import AadhaarDigilocker from "../../../../Components/AadhaarDigilocker";
import { useAuth } from "../../../../Contexts/AuthenticateProvider";

// Same DigiLocker flow as the customer app: the widget opens on this page and the Aadhaar
// data is fetched as soon as the associate completes it (see Components/AadhaarDigilocker).
// An associate's Aadhaar counts as done once its DigiLocker data is on the record.
const AadhaarStage = ({ associateDetails, onVerified }) => {
    const { hasPermission } = useAuth();
    const canSubmit = hasPermission("associate.edit");
    const associateId = associateDetails?.associateId;
    return (
        <AadhaarDigilocker
            initialAadhaarNo={associateDetails?.kyc?.aadhaar?.aadhaarNo}
            status={associateDetails?.kyc?.aadhaar?.aadhaarDetails ? "verified" : undefined}
            linkUrl={`/staff/client/associate/kyc/aadhaar/${associateId}`}
            verifyUrl={`/staff/client/associate/kyc/aadhaar/verify/${associateId}`}
            canSubmit={canSubmit}
            noPermissionText="You don't have permission to edit this associate's Aadhaar verification."
            onVerified={onVerified}
        />
    );
};

export default AadhaarStage;
